module.exports = __webpack_public_path__ + "static/media/icon_back.dfadc682.svg";